import React from 'react';

const LocationIconNew = ({ fill = "#6D7885", ...rest }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none" {...rest}>
      <path d="M4.79817 3.56867C5.9159 2.47329 7.42077 1.86327 8.98574 1.87117C10.5507 1.87907 12.0493 2.50426 13.156 3.61088C14.2626 4.7175 14.8878 6.21612 14.8957 7.78109C14.9036 9.34607 14.2935 10.8509 13.1982 11.9687L10.0587 15.1082C9.77737 15.3894 9.39591 15.5473 8.99816 15.5473C8.60042 15.5473 8.21896 15.3894 7.93767 15.1082L4.79817 11.9687C3.68433 10.8547 3.05859 9.34395 3.05859 7.76867C3.05859 6.19339 3.68433 4.68262 4.79817 3.56867Z" stroke={fill} strokeWidth="1.2" strokeLinejoin="round"/>
      <path d="M9 10.0195C10.2426 10.0195 11.25 9.01217 11.25 7.76953C11.25 6.52689 10.2426 5.51953 9 5.51953C7.75736 5.51953 6.75 6.52689 6.75 7.76953C6.75 9.01217 7.75736 10.0195 9 10.0195Z" stroke={fill} strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
};

export default LocationIconNew;